// extracted by mini-css-extract-plugin
export default {"modal":"jjeTjTwWhge4pAj88fO3"};